import Icon from '../../components/Icon'
import LoadingText from '../../components/LoadingText'
import isHexColorString from '../../helpers/isHexColorString'
import type { LoadableComponentProps } from '../../types'

interface InformationTilesProps {
  title: string
  tiles: {
    icon: string
    title: string
    description: string
  }[]
}

export default function InformationTiles({
  data,
  loading,
}: LoadableComponentProps<InformationTilesProps>) {
  const { title, tiles } = data || {}

  return (
    <div
      className='isolate mx-auto px-5 py-10'
      style={{ maxWidth: 'var(--layout-max-width, none)' }}
    >
      <h2 className='h5 mb-6'>
        {loading ? <LoadingText className='inline' textLength={15} /> : title}
      </h2>

      <div className='grid grid-cols-1 gap-4 md:grid-cols-3'>
        {loading
          ? Array.from({ length: 3 }).map((_, index) => (
              <div
                className='radius-md flex flex-col items-center p-5 text-center odd:bg-ecruwhite even:bg-steelblue lg:rounded-md'
                key={index}
              >
                <div
                  className='radius-pill mb-4 h-16 w-16'
                  style={{ backgroundColor: '#a4a4a4a1' }}
                />

                <h3 className='h6 mb-2'>
                  <LoadingText className='inline' textLength={10} />
                </h3>
                <p className='sm'>
                  <LoadingText className='mb-0.5' textLength={20} lines={3} />
                </p>
              </div>
            ))
          : tiles?.map(tile => (
              <div
                className='radius-md flex flex-col items-center p-5 text-center odd:bg-ecruwhite even:bg-steelblue lg:rounded-md'
                key={tile.title}
              >
                {tile.icon && isHexColorString(tile.icon) ? (
                  <div
                    className='radius-pill mb-4 h-16 w-16'
                    style={{ backgroundColor: tile.icon }}
                  />
                ) : (
                  <Icon name={tile.icon} className='mb-4' size={64} />
                )}
                <h3 className='h6 mb-2'>{tile.title}</h3>
                <p className='sm'>{tile.description}</p>
              </div>
            ))}
      </div>
    </div>
  )
}
